import React from 'react';
import {
  BaseEdge,
  EdgeLabelRenderer,
  EdgeProps,
  getBezierPath,
} from 'reactflow';
import { CustomSparkButtonEdge } from './Custom';

export default function SparkButtonEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
}: EdgeProps) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <React.Fragment>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer key={id}>
        <CustomSparkButtonEdge
          labelX={labelX}
          labelY={labelY}
          isPreview={data?.isPreviewNode}
        />
      </EdgeLabelRenderer>
    </React.Fragment>
  );
}
